export default [
  [
    {
      cause: 'อุบัติเหตุการขนส่ง',
      field: 'totalNumber',
      rank: 7,
      value: 16456,
    },
    {
      cause: 'อุบัติเหตุการขนส่ง',
      field: 'avgYearLostPerDeath',
      rank: 1,
      value: 34.11,
    },
    { cause: 'อุบัติเหตุการขนส่ง', field: 'totalLost', rank: 1, value: 561287 },
  ],
  [
    {
      cause: 'โรคหลอดเลือดในสมอง',
      field: 'totalNumber',
      rank: 1,
      value: 30837,
    },
    {
      cause: 'โรคหลอดเลือดในสมอง',
      field: 'avgYearLostPerDeath',
      rank: 5,
      value: 17.55,
    },
    {
      cause: 'โรคหลอดเลือดในสมอง',
      field: 'totalLost',
      rank: 2,
      value: 541156.75,
    },
  ],
  [
    { cause: 'ปอดบวม', field: 'totalNumber', rank: 2, value: 29568 },
    {
      cause: 'ปอดบวม',
      field: 'avgYearLostPerDeath',
      rank: 7,
      value: 15.51,
    },
    { cause: 'ปอดบวม', field: 'totalLost', rank: 3, value: 458568 },
  ],
  [
    { cause: 'โลหิตเป็นพิษ', field: 'totalNumber', rank: 4, value: 21036 },
    {
      cause: 'โลหิตเป็นพิษ',
      field: 'avgYearLostPerDeath',
      rank: 4,
      value: 17.56,
    },
    { cause: 'โลหิตเป็นพิษ', field: 'totalLost', rank: 4, value: 369502.5 },
  ],
  [
    { cause: 'โรคหัวใจขาดเลือด', field: 'totalNumber', rank: 5, value: 20786 },
    {
      cause: 'โรคหัวใจขาดเลือด',
      field: 'avgYearLostPerDeath',
      rank: 6,
      value: 16.67,
    },
    { cause: 'โรคหัวใจขาดเลือด', field: 'totalLost', rank: 5, value: 346586 },
  ],
  [
    {
      cause: 'โรคของระบบสืบพันธุ์และทางเดินปัสสาวะทีเหลืออยู่',
      field: 'totalNumber',
      rank: 3,
      value: 22798,
    },
    {
      cause: 'โรคของระบบสืบพันธุ์และทางเดินปัสสาวะทีเหลืออยู่',
      field: 'avgYearLostPerDeath',
      rank: 9,
      value: 14.74,
    },
    {
      cause: 'โรคของระบบสืบพันธุ์และทางเดินปัสสาวะทีเหลืออยู่',
      field: 'totalLost',
      rank: 6,
      value: 336056.5,
    },
  ],
  [
    {
      cause: 'เนืองอกชนิดร้ายทีเหลืออยู่',
      field: 'totalNumber',
      rank: 6,
      value: 17247,
    },
    {
      cause: 'เนืองอกชนิดร้ายทีเหลืออยู่',
      field: 'avgYearLostPerDeath',
      rank: 3,
      value: 18.34,
    },
    {
      cause: 'เนืองอกชนิดร้ายทีเหลืออยู่',
      field: 'totalLost',
      rank: 7,
      value: 316314,
    },
  ],
  [
    {
      cause: 'เนืองอกร้ายที่ตับและท่อน้ำดีในตับ',
      field: 'totalNumber',
      rank: 8,
      value: 15912,
    },
    {
      cause: 'เนืองอกร้ายที่ตับและท่อน้ำดีในตับ',
      field: 'avgYearLostPerDeath',
      rank: 2,
      value: 19.71,
    },
    {
      cause: 'เนืองอกร้ายที่ตับและท่อน้ำดีในตับ',
      field: 'totalLost',
      rank: 8,
      value: 313601.5,
    },
  ],
  [
    { cause: 'เบาหวาน', field: 'totalNumber', rank: 9, value: 14306 },
    {
      cause: 'เบาหวาน',
      field: 'avgYearLostPerDeath',
      rank: 8,
      value: 14.78,
    },
    { cause: 'เบาหวาน', field: 'totalLost', rank: 9, value: 211438.75 },
  ],
  [
    {
      cause: 'โรคระบบประสาททีเหลืออยู่',
      field: 'totalNumber',
      rank: 10,
      value: 11674,
    },
    {
      cause: 'โรคระบบประสาททีเหลืออยู่',
      field: 'avgYearLostPerDeath',
      rank: 10,
      value: 12.66,
    },
    {
      cause: 'โรคระบบประสาททีเหลืออยู่',
      field: 'totalLost',
      rank: 10,
      value: 147757.5,
    },
  ],
];
